import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { FeatureFlagProvider, TFeatureFlagValue } from '@mopla/business-logic';
import { useLogger } from '@mopla/logger';

import { environment } from '../environments/environment';
import ViewEntrypoint from '../view/ViewEntrypoint';

import { queryClient } from './queryClient';
import { useManageRxDBReplications } from './useManageRxDBReplications';
import { withDBObservableDataContext } from './withDBObservableDataContext';

export const App = withDBObservableDataContext(() => {
	const logger = useLogger('app');
	useManageRxDBReplications();

	useEffect(() => {
		logger.breadcrumb('Passenger app mounted');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<FeatureFlagProvider
				localFlags={
					environment.featureFlags as unknown as Record<
						string,
						TFeatureFlagValue
					>
				}
			>
				<ViewEntrypoint />
			</FeatureFlagProvider>
			{process.env.NODE_ENV !== 'production' && (
				<ReactQueryDevtools initialIsOpen={false} />
			)}
		</QueryClientProvider>
	);
});

App.displayName = 'App';
